import AppRouter from './router';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './layouts/ThemeProvider';
import { Toaster } from '@/components/Sonner';
import { ConfirmDialog } from '@/components/ConfirmDialog';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@/lib/queryClient';
import { APP_CONFIG, FEATURE_CONFIG } from './config/env';
import { useEffect } from 'react';
import { setupFirstScreenPerformance, setupRoutePerformance } from '@/utils/performance';
import { UploadTaskHost } from '@/features/material-upload';

/**
 * 应用根组件
 * 集成路由系统、错误边界、主题提供者
 */
function App() {
  useEffect(() => {
    setupFirstScreenPerformance();
    setupRoutePerformance();
  }, []);

  useEffect(() => {
    /**
     * 移除 index.html 内联的首屏骨架。
     * 该骨架覆盖「入口 chunk 到达前」的白屏窗口，React 首次提交后即失效；
     * 它渲染在 #root 内，React 挂载时通常已自动清空容器，这里的兜底移除保证不会遮挡真实界面。
     */
    document.querySelector('[data-app-boot-skeleton]')?.remove();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider storageKey="ui-theme">
        <ErrorBoundary>
          <div className="App h-screen">
            <AppRouter />
            {/* Toast 通知系统 */}
            <Toaster position="top-center" duration={3000} />
            {/* 全局确认弹窗 */}
            <ConfirmDialog />
            {/* 上传任务全局宿主：在 AppRouter 之外，切换路由不卸载，保证上传与刷新守卫延续 */}
            <UploadTaskHost />
          </div>
        </ErrorBoundary>
      </ThemeProvider>
      {APP_CONFIG.isDev && FEATURE_CONFIG.enableReactQueryDevtools && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
}

export default App;
